// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"54292a4b","667":"ba571e3e","839":"48e71f99","915":"823c6c7e"}[chunkId] + ".chunk.js";
};